import { useQuery, useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";

const api = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const useAddresses = () => {
  const { token } = useContext(AuthContext);
  return useQuery(
    "addresses",
    async () => {
      const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/customer/addresses`, api(token));
      return res.data.addresses;
    },
    { enabled: !!token }
  );
};

export const useCreateAddress = () => {
  const { token } = useContext(AuthContext);
  const qc = useQueryClient();
  return useMutation(
    (data) => axios.post(`${process.env.REACT_APP_SERVER_URL}/customer/addresses`, data, api(token)),
    { onSuccess: () => qc.invalidateQueries("addresses") }
  );
};

export const useUpdateAddress = () => {
  const { token } = useContext(AuthContext);
  const qc = useQueryClient();
  return useMutation(
    ({ id, data }) => axios.patch(`${process.env.REACT_APP_SERVER_URL}/customer/addresses/${id}`, data, api(token)),
    { onSuccess: () => qc.invalidateQueries("addresses") }
  );
};

export const useDeleteAddress = () => {
  const { token } = useContext(AuthContext);
  const qc = useQueryClient();
  return useMutation(
    (id) => axios.delete(`${process.env.REACT_APP_SERVER_URL}/customer/addresses/${id}`, api(token)),
    { onSuccess: () => qc.invalidateQueries("addresses") }
  );
};

export const useSetDefaultAddress = () => {
  const { token } = useContext(AuthContext);
  const qc = useQueryClient();
  return useMutation(
    (id) => axios.patch(`${process.env.REACT_APP_SERVER_URL}/customer/addresses/${id}/default`, {}, api(token)),
    { onSuccess: () => qc.invalidateQueries("addresses") }
  );
};
